<template>
  <div class="d-flex flex-column align-items-end gap-1" style="min-width: 140px">
    <span v-if="isNew" class="badge bg-green-lt">{{ $t('common.new') }}</span>
    <span v-if="isExpired" class="badge bg-red-lt">{{ $t('common.expired') }}</span>
    <span v-else-if="expiresSoon" class="badge bg-orange-lt">{{ $t('external_job_markets.expires_soon') }}</span>
    <small class="text-muted text-nowrap">{{ lastSeenText }}</small>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatDistanceToNow, parseISO } from 'date-fns';
import type { ExternalJobMarketJob } from '@/types/externalJobMarket';

const props = defineProps<{ job: ExternalJobMarketJob }>();

const ONE_DAY = 24 * 60 * 60 * 1000;

const isNew = computed(() => {
  return Date.now() - new Date(props.job.created_at).getTime() < ONE_DAY;
});

const expiresDate = computed(() => (props.job.expires ? new Date(props.job.expires) : null));

const isExpired = computed(() => !!expiresDate.value && expiresDate.value.getTime() <= Date.now());

const expiresSoon = computed(() => {
  if (!expiresDate.value) return false;
  const diff = expiresDate.value.getTime() - Date.now();
  return diff > 0 && diff < 2 * ONE_DAY;
});

const lastSeenText = computed(() => {
  try {
    const date = parseISO(props.job.created_at);
    return formatDistanceToNow(date, { addSuffix: true, locale: window.__pjas_date_locale?.[window.__pjas_locale] });
  } catch {
    return '';
  }
});
</script>
